import React, { useEffect, useState } from 'react'
import styles from './DigitalInstrumentalCluster.module.css'
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_jupiter";
import { formatTo12Hour, subtractTime } from "../../../util/dateTimeUtils";

function TopKpiCards_Jupiter(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [countData, setCountData] = useState([]);
  const [countDataTot, setCountDataTot] = useState(0);
  const [countDataAct, setCountDataAct] = useState(0);
  const [apiEndArray, setApiEndArray] = useState(['driving', 'idling', 'charging', 'offline', 'data_pack_expired']);

  const now = new Date();
  // Get 30 minutes ago
  const thirtyMinutesAgo = subtractTime(now, { minutes: 30 });
  const thirtyMinuteMinus = formatTo12Hour(thirtyMinutesAgo);
  // Get 20 days ago
  const twentyDaysAgo = subtractTime(now, { days: 20 });
  const twentyDaysMinus = formatTo12Hour(twentyDaysAgo);

  useEffect(() => {
    if (props.cardsData.apiEnd !== '') {
      fetchData(
        {
          url: API_URL_MAIN + "jupiter_dic/" + props.cardsData.apiEnd,
          body: { filterdata: props.gloablfilter },
        },
        appyData
      );
    } else {
      apiEndArray.map((ele, i) => {
        fetchData(
          {
            url: API_URL_MAIN + "jupiter_dic/" + ele + '_cnt',
            body: { filterdata: props.gloablfilter, thirtyMinuteMinus: thirtyMinuteMinus, twentyDaysMinus: twentyDaysMinus },
          },
          appyDataTotAct
        );
      })
    }
  }, [props.gloablfilter]);

  const appyData = (data) => {
    setCountData(data);
  };

  let tempCnt = 0
  let tempCntAct = 0
  const appyDataTotAct = (data) => {
    const keyName = Object.keys(data)[0];
    apiEndArray.map((ele, i) => {
      if (ele === keyName) {
        tempCnt += data?.[ele].doc_count
        setCountDataTot(tempCnt)
      }
      if (i !== 4 && ele === keyName) {
        tempCntAct += data?.[ele].doc_count
        setCountDataAct(tempCntAct)
      }
    })
  }

  return (
    <div class={`${styles.kipBoxes} ${styles.kpiHeight} p-2 py-2 d-flex align-items-center`}>
      <img src={`/assets/images_realTimeFaultCode/kpiIcons/${props.cardsData.imgNm}.png`} width={40} height={40} />
      <div className="ps-2">
        {
          (props.cardsData.apiEnd !== '') ?
            (<>
              <p class={`h5 m-0 ${styles.fw_600} ${styles.textColorGreen}`}>{(props.cardsData.apiEnd === 'BMS_fault_count') ? countData?.all?.vehicleId_count?.doc_count : (props.cardsData.apiEnd === 'OBC_fault_count' || props.cardsData.apiEnd === 'BCS_fault_count') ? countData?.vehicleId_count?.doc_count : (props.cardsData.apiEnd === 'tot_veh_fault_count') ? countData?.unique_vehicle_count?.value : countData[0]?.vehicleId_count?.doc_count}</p>
              <p className="m-0">
                <small class={`text-muted ${styles.fw_600}`}>{props.cardsData.cNm}</small>
              </p>
            </>
            )
            :
            (
              <>
                <p class={`h5 m-0 ${styles.fw_600} ${styles.textColorGreen}`}>{countDataTot}/{countDataAct}</p>
                <p className="m-0">
                  <small class={`text-muted ${styles.fw_600}`}>{props.cardsData.cNm}</small>
                </p>
              </>
            )
        }
      </div>
    </div>
  )
}

export default TopKpiCards_Jupiter